import { Dexes } from 'services/uniswap/utils';

export const dexNames: Record<Dexes, string> = {
  'uniswap-v2': 'Uniswap V2',
  'sushi-v2': 'Sushiswap V2',
  'pancake-v2': 'Pancake V2',
  'uniswap-v3': 'Uniswap V3',
  'sushi-v3': 'Sushiswap V3',
  'pancake-v3': 'Pancake V3',
};
